<template>
  <TableComp
    v-if="pointerDomains"
    :name="$t('global.pointer-domains')"
    :headers="headers"
    :status="pointerDomains.status"
    :pagination="pointerDomains.pagination"
    :sort="pointerDomains.sort"
    :number-of-items="pointerDomains.list.length"
    empty-image="pointer-domains"
    :empty-bold-message="$t('global.no-pointer-domains-bold-message')"
    :empty-message="$t('global.no-pointer-domains-message')"
    v-on:update:list="updateList"
    :header-actions="getActions()"
    :empty-actions="getEmptyActions()"
  >
    <template #content v-if="pointerDomains.status.isLoaded">
      <p class="mb-0">
        {{ $t("global.no-pointer-domains-message") }}
      </p>
    </template>
    <template #desktop>
      <tr v-for="pointer in pointerDomains.list" v-bind:key="pointer.id">
        <td>
          <span class="mr-2">{{ pointer.domain }}</span>
          <CopyToClipboard :text="pointer.domain" />
        </td>

        <td class="text-center">
          {{ pointer.type }}
        </td>

        <td class="text-end actions">
          <div class="d-flex justify-content-end mr-4">
            <ThreeDotsMenu v-if="!isMasterDomain(pointer)" :items="menuItems(pointer)" />
          </div>
        </td>
      </tr>
    </template>
    <template #mobile>
      <TableMobileRow v-for="pointer in pointerDomains.list" v-bind:key="pointer.id">
        <template #header>
          <div class="d-flex align-items-center">
            <!-- domain column -->
            <div class="flex-fill">
              <div class="d-flex align-items-center">
                <span class="mr-2">{{ pointer.domain }}</span>
                <CopyToClipboard :text="pointer.domain" />
              </div>
            </div>

            <!-- dropdown menu column -->
            <div>
              <div class="d-flex justify-content-center">
                <ThreeDotsMenu v-if="!isMasterDomain(pointer)" :items="menuItems(pointer)" />
              </div>
            </div>
          </div>
        </template>
        <template #content>
          <!-- pointer domain -->
          <div class="row">
            <div class="col">{{ $t("global.domain") }}:</div>
            <div class="col">
              <span class="mr-2">{{ pointer.domain }}</span>
              <CopyToClipboard :text="pointer.domain" />
            </div>
          </div>

          <!-- domain type -->
          <div class="row">
            <div class="col">{{ $t("global.type") }}:</div>
            <div class="col">
              {{ pointer.type }}
            </div>
          </div>
        </template>
      </TableMobileRow>
    </template>
  </TableComp>
</template>

<script>
import CopyToClipboard from "@/components/display/CopyToClipboard";
import NavLink from "@/classes/NavLink";
import PointerDomainAddModal from "@/components/smart/modals/PointerDomainAdd";
import PointerDomainDeleteModal from "@/components/smart/modals/PointerDomainDelete";
import store from "@/store";
import TableComp from "@/components/display/table/TableComp";
import TableHeader from "@/classes/TableHeader";
import TableMobileRow from "@/components/display/table/TableMobileRow";
import ThreeDotsMenu from "@/components/display/ThreeDotsMenu";

export default {
  name: "PointerDomainsTable",
  props: {
    pointerDomains: Object,
    site: {
      type: Object,
    },
  },
  components: {
    TableComp,
    TableMobileRow,
    ThreeDotsMenu,
    CopyToClipboard,
  },
  setup(props, { root }) {
    const headers = [
      new TableHeader(root.$t("global.domain")),
      new TableHeader(root.$t("global.type"), "justify-content-center"),
      new TableHeader(),
    ];

    const addPointerDomain = () => {
      store.dispatch("modals/open", {
        template: PointerDomainAddModal,
        data: { site: props.site },
      });
    };

    const deletePointerDomain = (pointerDomain) => {
      store.dispatch("modals/open", {
        template: PointerDomainDeleteModal,
        data: { pointerDomain, site: props.site },
      });
    };

    const getActions = () => {
      if (!props.pointerDomains.status.isLoaded) {
        return [];
      }

      return [
        new NavLink(
          root.$t("global.add-pointer-domain"),
          "add",
          addPointerDomain,
          false,
          null,
          "epsilon"
        ),
      ];
    };

    const getEmptyActions = () => [
      new NavLink(
        root.$t("global.add-pointer-domain"),
        null,
        addPointerDomain,
        false,
        "primaryOutline"
      ),
    ];

    const isMasterDomain = (pointerDomain) => pointerDomain.domain === props.site.domain;

    const menuItems = (pointerDomain) => {
      return [
        new NavLink(
          root.$t("global.delete"),
          null,
          () => deletePointerDomain(pointerDomain),
          null,
          "danger"
        ),
      ];
    };

    const updateList = () => {
      store.dispatch("pointerDomains/getList", {
        siteId: props.site.id,
      });
    };

    return {
      getEmptyActions,
      headers,
      menuItems,
      updateList,
      getActions,
      isMasterDomain,
    };
  },
};
</script>
